"use strict";
// Environment selection does not work properly. Also insert the prod environment here to make sure that on is used.
Object.defineProperty(exports, "__esModule", { value: true });
exports.environment = {
    production: true,
    version: require('../../package.json').version,
    serverUrl: '/api',
    defaultLanguage: 'en-UK',
    supportedLanguages: [
        { code: 'en-UK', name: 'English' },
        { code: 'nl-NL', name: 'Nederlands' },
        { code: 'es-ES', name: 'Español' },
        { code: 'it-IT', name: 'Italiano' }
    ]
};
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// export const environment = {
//     production: false,
//     version: '(dev)',
//     serverUrl: '/api',
//     defaultLanguage: 'en-UK',
//     supportedLanguages: [
//         {code: 'en-UK', name: 'English'},
//         {code: 'nl-NL', name: 'Nederlands'},
//         {code: 'es-ES', name: 'Español'},
//         {code: 'it-IT', name: 'Italiano'}
//     ]
// };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52aXJvbm1lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJlbnZpcm9ubWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsb0hBQW9IOztBQUV2RyxRQUFBLFdBQVcsR0FBRztJQUN2QixVQUFVLEVBQUUsSUFBSTtJQUNoQixPQUFPLEVBQUUsT0FBTyxDQUFDLG9CQUFvQixDQUFDLENBQUMsT0FBTztJQUM5QyxTQUFTLEVBQUUsTUFBTTtJQUNqQixlQUFlLEVBQUUsT0FBTztJQUN4QixrQkFBa0IsRUFBRTtRQUNoQixFQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLFNBQVMsRUFBQztRQUNoQyxFQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLFlBQVksRUFBQztRQUNuQyxFQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLFNBQVMsRUFBQztRQUNoQyxFQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLFVBQVUsRUFBQztLQUNwQztDQUNKLENBQUM7QUFNRixtRkFBbUY7QUFDbkYsOEZBQThGO0FBQzlGLHlFQUF5RTtBQUN6RSxnRkFBZ0Y7QUFFaEYsK0JBQStCO0FBQy9CLHlCQUF5QjtBQUN6Qix3QkFBd0I7QUFDeEIseUJBQXlCO0FBQ3pCLGdDQUFnQztBQUNoQyw0QkFBNEI7QUFDNUIsNENBQTRDO0FBQzVDLCtDQUErQztBQUMvQyw0Q0FBNEM7QUFDNUMsNENBQTRDO0FBQzVDLFFBQVE7QUFDUixLQUFLIn0=


//////////////////
// WEBPACK FOOTER
// ./src/environments/environment.ts
// module id = 632
// module chunks = 0